import { queryOptions } from '@tanstack/react-query';
import { getPerformanceSummaryFunction } from './getPerformanceSummaryQueryFunction';
import { GetPerformanceSummaryQueryParamsType } from './getPerformanceSummaryQuery.type';

export const getPerformanceSummaryQueryOptions = (
  params: GetPerformanceSummaryQueryParamsType,
) =>
  queryOptions({
    queryKey: ['PerformanceSummary', params],
    queryFn: () => getPerformanceSummaryFunction(params),
  });
